import {AString} from '@mintdata/mint-kit/api/values/AString';
import {AStringEnum} from '@mintdata/mint-kit/api/values/AStringEnum';

export class Side extends AStringEnum
{
    public constructor(value:AString)
    {
        super(value, Side.types);
    }

    public toString():string
    {
        return this.value ? this.value.toString() : null;
    }

    public static LEFT = new AString('Left');
    public static RIGHT = new AString('Right');

    public static types:Array<AString> = [
        Side.LEFT,
        Side.RIGHT,
    ];

    public static left():Side
    {
        return new Side(Side.LEFT);
    }

    public static right():Side
    {
        return new Side(Side.RIGHT);
    }

}
